var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLsExpired({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Level_Status_Icon",
    "data-name": "Level Status Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#e1e7e9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(2 2)",
    fill: "#9e1b32"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2905",
    "data-name": "Group 2905",
    transform: "translate(-21095 -23065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5759",
    "data-name": "Path 5759",
    d: "M348.384,25.689a1.551,1.551,0,1,1,1.551-1.551A1.551,1.551,0,0,1,348.384,25.689Z",
    transform: "translate(20760.615 23059.902)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5760",
    "data-name": "Path 5760",
    d: "M348.2,23.407a.775.775,0,0,1-.776-.776V15.653a.776.776,0,0,1,1.551,0v6.978A.775.775,0,0,1,348.2,23.407Z",
    transform: "translate(20760.797 23057.531)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLsExpired);
export default __webpack_public_path__ + "static/media/icon_ls_expired.8ac44632de5174ec88837f6237ac29cc.svg";
export { ForwardRef as ReactComponent };